import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import './css/app.scss';

import(/* webpackPreload: true, webpackChunkName: "ui-components" */'./Services/Sentry');

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

window.statusBar = (device) => {
  if (device) {
    window.localStorage.setItem('statusBar', device);
  } else {
    window.localStorage.removeItem('statusBar');
  }
}

window.roleOverride = (role) => {
  if (role) {
    window.localStorage.setItem('roleOverride', role);
  } else {
    window.localStorage.removeItem('roleOverride');
  }

  window.location.reload();
}

window.toggleAdmin = () => {
  if (window.localStorage.getItem('adminDisabled')) {
    window.localStorage.removeItem('adminDisabled');
  } else {
    window.localStorage.setItem('adminDisabled', 'true');
  }

  window.location.reload();
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
